import Lottie from "lottie-react";
import loading from "../assets/images/loading_dots.json"

const LoadingDots = () => {

    return (
        <div className="tw-w-full tw-mt-4 tw-flex tw-justify-center tw-items-center tw-h-full">
            <div className="tw-w-80 sm:tw-w-96 md:tw-w-[250px]">
                <Lottie animationData={loading} loop={true} />
            </div>
        </div>
    )
}

export default LoadingDots